<template>
  <Loader v-if="loading"/>
  <div v-else>
    <div class="columns is-desktop">

      <section class="column is-two-thirds is-offset-2">
        <div class="flex-space-between">
          <h2 class="title is-2">User Accounts</h2>
          <section>
            <input
            class="button is-primary"
            type='button'
            name='Add User'
            @click='toggleShowAddUserModal()'
            value="+ Add User"/>
          </section>
        </div>
        <section>
          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>School</th>
                <th>Role</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>

              <tr v-for="u in users">
                <td class="d-flex">
                  <img
                  class="user-profile-image magic-button cursor-pointer"
                  :src="u.avatar_url"/>
                  <section>
                    <strong>{{ u.name }}</strong><br />{{ u.email }}
                  </section>
                </td>
                <td>
                  {{ u.school }}
                </td>
                <td>
                  <span v-if="u.is_coach" class="tag is-rounded is-primary">Coach</span>
                  <span v-if="u.is_group_admin" class="tag is-rounded is-warning">Admin</span>
                </td>
                <td>
                  <span class="flex-space-between">
                    <input
                      v-if="is_admin"
                      class="button is-danger is-small"
                      type='button'
                      name='Archive'
                      @click='archive_user(u.id, true)'
                      value="Archive" />
                    <div v-if="u.activated">Activated</div>
                    <div v-else>Needs Activating</div>
                  </span>
                </td>
                <td>
                  <input v-if="!u.activated"
                  class="button is-primary is-small is-outlined"
                  type='button'
                  name='resend'
                  @click='createInvite(u.email)'
                  value="resend email activation link"/>
                </td>
              </tr>

              <tr v-for="inv in invites" v-if="notUserYet(inv.email)">
                <td>{{ inv.email }}</td>
                <td></td>
                <td></td>
                <td>Invited</td>
                <td>
                  <input
                  class="button is-info is-small is-outlined"
                  type='button'
                  name='resend invite'
                  @click='resendInvite(inv.id, true)'
                  value="resend invitation"/>
                </td>
              </tr>

            </tbody>
          </table>
        </section>
      </section>

    </div>
    <AddUser
    @cancel='toggleShowAddUserModal'
    title="Add New User"
    message="What is their email address"
    :show="showAddUserModal"
    />

    <section v-if="archived_users.length > 0" class="column is-two-thirds is-offset-2">
      <div class="flex-space-between">
        <h2 class="title is-2">Archived Accounts</h2>
      </div>
      <section>
        <div class="d-flex" v-for="u in archived_users">
          <img
          class="user-profile-image magic-button cursor-pointer"
          :src="u.avatar_url"/>
          <section>
            <strong>{{ u.name }}</strong><br />{{ u.email }}
          </section>
          <input
            v-if="is_admin"
            class="button is-primary is-small"
            type='button'
            name='Re-activate'
            @click='archive_user(u.id, false)'
            value="Re-activate" />
        </div>
      </section>
    </section>

  </div>

</template>

<script>
  import axios from 'axios'

  import BasePage from './BasePage.vue'
  import Confirm from './Confirm.vue'
  import AddUser from './AddUser.vue'

  import store from '../store.js'

  import Loader from './Loader.vue'

  export default {
    name: 'OrgManage',
    components: {
      BasePage,
      Loader,
      Confirm,
      AddUser,
    },
    async mounted () {
      await store.dispatch('fetchGroup')
      await this.fetchInvites()
      this.loading = false
    },
    methods: {
      toggleShowAddUserModal () {
        store.commit('toggleShowAddUserModal')
      },
      async fetchInvites () {
        return axios.get('/api/v1/invites/', { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
        .then(response => {
          this.invites = response.data
        })
      },
      async resendInvite (inviteID, invite) {
        await store.dispatch('resendInvite', { inviteID, invite })
      },
      async createInvite (email) {
        await store.dispatch('createInvite', { email: email })
      },
      notUserYet (email) {
        return this.users.filter(u => u.email === email).length === 0
      },
      async archive_user (userID, archive) {
        if (archive) {
          return axios.post(`/api/v1/users/${userID}/archive/`, {}, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
          .then(() => {
            store.commit('archiveUser', { userID, archive })
          })
        } else {
          return axios.delete(`/api/v1/users/${userID}/archive/`, { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
          .then(() => {
            store.commit('archiveUser', { userID, archive })
          })
        }
      }
    },
    computed: {
      users () {
        return this.group.users.filter(u => !u.archived).sort((a, b) => a.id > b.id)
      },
      archived_users () {
        return this.group.users.filter(u => u.archived).sort((a, b) => a.id > b.id)
      },
      is_admin () {
        return store.state.user.is_admin
      },
      isPro () {
        return store.state.user.is_pro
      },
      userInput () {
        return store.state.userInput
      },
      group () {
        return store.state.group
      },
      showAddUserModal () {
        return store.state.showAddUserModal
      },
      numTeachers () {
        return this.users.filter(x => !x.is_coach && !x.is_group_admin).length
      },
      numCoaches () {
        return this.users.filter(x => x.is_coach && !x.is_group_admin).length
      },
      numAdmins () {
        return this.users.filter(x => x.is_group_admin).length
      },
    },
    data () {
      return {
        loading: true,
        activeTeamID: null,
        query: '',
        editing: false,
        deleting: false,
        showDelete: false,
        showAddUser: false,
        userText: null,
        isGroupAdmin: true,
        invites: [],
      }
    },
  }

</script>

<style lang="scss" scoped>

.title.team {
  margin-bottom: 0;
}

a.title {
  color: #23c6c8;
}

a.title:not(:last-child) {
  margin-bottom: 0;
}

.user-count {
  margin-left: 5px;
  margin-right: 5px;
}

ul.team-list {
  margin-top: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// OrgManage.vue?6370442a